import api, { authService } from './api';

export const inventoryService = {
  getSnapshot: async () => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.get('/inventory/snapshot', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        items: response.data.items || [],
        totalCount: response.data.total_count || 0,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch inventory snapshot',
      };
    }
  },

  rebuildSnapshot: async () => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.post('/inventory/snapshot/rebuild', {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to rebuild inventory snapshot',
      };
    }
  },
};

